// useSupplies.js
import { useState } from "react";
import { getSuppliesByProviders, patchSuppliesByProviders } from "../../../utils";

export function useSupplies() {
  const [supplies, setSupplies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);


  const fetchSupplies = async () => {
    setLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      const data = await getSuppliesByProviders({ token });
      setSupplies(data.items);
    } catch (err) {
      console.error(err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const patchSuppliesPrice = async (supplyId, price) => {

    setLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      await patchSuppliesByProviders(token, supplyId, price);
    } catch (error) {
      setError(error)
    }
  };

  return { fetchSupplies, patchSuppliesPrice, supplies, loading, error };
}
